import { render, staticRenderFns } from "./PatientTreatmentList.vue?vue&type=template&id=0e489db3&"
import script from "./PatientTreatmentList.vue?vue&type=script&lang=js&"
export * from "./PatientTreatmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports